import React,{useState, useEffect}  from 'react';
import {Card} from 'react-bootstrap'
import Sides from '../Bars/Diffjvscs';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jscfunction(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
 


return(
    <div>
      <Sides />
      <Helmet>
 
 <title>Difference Between Java and C# Function tutorial For Beginners</title>
<meta name="description" content="Difference Between Java and C# Function tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, java tutorial,c# tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,Csharp(C#),Java,Python,function,tutorial for begineers,Difference Between Java and C#,Difference between program and code,java tutorial for begineers,C# tutorial for begineers,java tutorial for begineers,code,exampler,which online website to learn code,Difference Between Java and C# ,java vs c#,java vs Python" />
<link rel="canonical" href="https://www.codeexampler.com/java-vs-csharp-function" />
</Helmet>
<div className='lg:pl-56'>
    <h1 className="m-4 mh1">Java vs CSharp method (function)</h1>
    <div className="first">
        <a href="/java-vs-csharp-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
     
        </div>
    <p className="mt-3 para">The methods contain one more statement and each method performs only one task
        <br/>
  Each method gives the name and after this name is used to call the method.  
    </p>
    <h2 className="mt-4 mh2">
java methods Syntax:</h2>


    <Card className='inde' border='primary m-4'>
  <Card.Header as="h5">methods in java Syntax:</Card.Header>
  <Card.Body>
  
    <Card.Text>
    Method name(parenthesis or parameter -list)<br/>
    &#123;<br/>
    &#47;&#47;body of method<br/>
&#125;<br/>
    </Card.Text>
  </Card.Body>
</Card>

    <h2 className="mt-4 mh2">
C# methods Syntax:</h2>

    <Card className='inde' border='primary m-4'>
  <Card.Header as="h5">c# methods Syntax:</Card.Header>
  <Card.Body>
    <Card.Text>
    Method name(parenthesis or parameter -list)<br/>
    &#123;<br/>
    &#47;&#47;body of method<br/>
&#125;<br/>
    </Card.Text>
  </Card.Body>
</Card>


<h3 className="mt-4">Java method Example</h3>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q-use one method in Java Example?</Card.Header>
  <Card.Body>
    <Card.Text>
    class school<br/>
    &#123;<br/>
    public void teachers()<br/>
    &#123;<br/>
    System.out.println("teaching");<br/>
    &#125;<br/>
 public static void main(String[] args) <br/>
 &#123;<br/>  
        System.out.println("start method");<br/>
    school s =new school();<br/>
    s.teachers ();<br/>
    &#125;<br/>
    &#125;
    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br/>start method<br/>
teaching</Card.Footer>
</Card>
<h3 className="mt-4">C# method Example</h3>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q-Use one method in C# Example?</Card.Header>
  <Card.Body>
    <Card.Text>
    class school<br/>
    &#123;<br/>
    public void teachers()<br/>
    &#123;<br/>
    Console.WriteLine("teaching");<br/>
    &#125;<br/>
 public static void main(String[] args) <br/>
 &#123;<br/>  
 Console.WriteLine("start method");<br/>
    school s =new school();<br/>
    s.teachers ();<br/>
    &#125;<br/>
    &#125;
    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br/>start method<br/>
teaching</Card.Footer>
</Card>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/java-vs-csharp-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        
        </div>
        </div>
    </div>
)

}
export default Jscfunction;